import React from 'react'
import { translate } from 'react-translate'
import Button from '../../../../../components/Buttons'
import { purposeSelectorOptions } from './PurposeSelector.constants';

import './PurposeSelector.scss'

const PurposeSelectorComponent = ({
  onSelectOption, t, value, className, border
}) => {

  const selectOption = option => {
    onSelectOption(option)
  }
  return <div className={`ljr-purpose-selector ${className || ''} ${border ? 'add-border' : ''}`}>
    <Button
      text={t('residencial')}
      classes={`btn-primary purpose-selector-button ${value === purposeSelectorOptions.residencial ? 'active' : ''}`}
      clickButton={() => selectOption(purposeSelectorOptions.residencial)}
    />
    <Button
      text={t('comercial')}
      classes={`btn-primary purpose-selector-button ${value === purposeSelectorOptions.comercial ? 'active' : ''}`}
      clickButton={() => selectOption(purposeSelectorOptions.comercial)}
    />
  </div>
}

const PurposeSelector = translate('PurposeSelector')(PurposeSelectorComponent)

export {
  PurposeSelector,
}



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/PurposeSelector/PurposeSelector.component.js